import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AutosizeDirective} from './autosize.directive';

@NgModule({
  declarations: [AutosizeDirective],
  imports: [CommonModule],
  exports: [AutosizeDirective]
})
export class AutosizeModule {}
